import { ValueAndDisplay } from "../../../../types/cobeTypes";

type Props = {
  creditRate: ValueAndDisplay;
};

export const Icon = ({ creditRate }: Props) => {
  const APRDisplay = `${creditRate.display} APR`;
  return (
    <svg
      width="38"
      height="38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      aria-labelledby="ifcIcon"
      role="img"
    >
      <title id="ifcIcon">{APRDisplay}</title>
      <text
        x="50%"
        y={creditRate.value > 0 ? "50%" : "48%"}
        dx="0"
        dy="0.15em"
        textAnchor="middle"
        stroke="black"
        fill="black"
        fontSize={creditRate.value > 0 ? "1em" : "1.3em"}
      >
        {creditRate.display}
      </text>
      <text
        x="50%"
        y="75%"
        dx="0"
        dy="0.15em"
        textAnchor="middle"
        stroke="black"
        fill="black"
        fontSize="0.7em"
      >
        A P R
      </text>
      <circle cx="24" cy="24" r="22" stroke="#141414" strokeWidth="2"></circle>
    </svg>
  );
};
